<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm">
    <button
      class="flex items-center gap-2 select-none w-full rounded-lg bg-n-slate-2 outline outline-1 outline-n-weak m-0 cursor-grab justify-between py-2 px-4 drag-handle"
      :class="{ 'rounded-bl-none rounded-br-none': isOpen }"
      :aria-expanded="isOpen"
      @click.stop="onToggle"
    >
      <div class="flex min-w-0 items-center">
        <EmojiOrIcon class="inline-block w-5" :icon="icon" :emoji="emoji" />
        <h5 class="text-n-slate-12 text-sm mb-0 py-0 pr-2 pl-0 truncate">
          {{ title }}
        </h5>
      </div>
      <div class="flex min-w-0 shrink-0 items-center gap-2">
        <slot name="button" />
        <!-- Seta discreta em área própria: não sobrepõe o conteúdo do slot. -->
        <span
          class="i-hugeicons-arrow-down-01 size-4 shrink-0 text-n-slate-11 transition-transform duration-150 motion-reduce:transition-none"
          :class="{ 'rotate-180': isOpen }"
          aria-hidden="true"
        />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="outline outline-1 outline-n-weak -mt-[-1px] border-t-0 rounded-br-lg rounded-bl-lg"
      :class="compact ? 'p-0' : 'px-2 py-4'"
    >
      <slot />
    </div>
  </div>
</template>
